/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bright_Rosy_Tiger_SinkInputs */

const en_bright_rosy_tiger_sink = /** @type {(inputs: Bright_Rosy_Tiger_SinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Membership updated`)
};

const de_bright_rosy_tiger_sink = /** @type {(inputs: Bright_Rosy_Tiger_SinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutzer aktualisiert`)
};

/**
* | output |
* | --- |
* | "Membership updated" |
*
* @param {Bright_Rosy_Tiger_SinkInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const bright_rosy_tiger_sink = /** @type {((inputs?: Bright_Rosy_Tiger_SinkInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bright_Rosy_Tiger_SinkInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_bright_rosy_tiger_sink(inputs)
	return de_bright_rosy_tiger_sink(inputs)
});